import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
import router from '@/router'
import { getBaseURL, getTimeout, getCurrentEnv } from '@/config/env'

// 创建axios实例
const service = axios.create({
  baseURL: getBaseURL(), // 动态获取API地址
  timeout: getTimeout() // 动态获取超时时间
})

// 监听环境变化（用户可能在其他标签页切换了环境）
window.addEventListener('storage', (e) => {
  if (e.key === 'API_ENV') {
    console.log('检测到环境切换，即将刷新页面...')
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }
})

// 在控制台输出当前环境信息
console.log('========================================')
console.log('当前API环境:', getCurrentEnv())
console.log('API地址:', getBaseURL())
console.log('========================================')


// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送前做一些处理
    const token = store.getters.token
    if (token) {
      // 让每个请求携带token
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // 规范化URL，避免 /api/api 重复
    try {
      const base = (config.baseURL || '').replace(/\/$/, '')
      if (base.endsWith('/api') && typeof config.url === 'string' && config.url.startsWith('/api')) {
        config.url = config.url.replace(/^\/api/, '') || '/'
      }
    } catch (e) { /* noop */ }
    return config
  },
  error => {
    // 请求错误处理
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response
    // 如果状态码不是200，则判断为错误
    if (res.status > 299) {
      ElMessage({
        message: res.data.message || '请求错误',
        type: 'error',
        duration: 5 * 1000
      })

      // 401: 未登录或token过期
      // if (res.status === 401) {
      //   // 重新登录
      //   ElMessage({
      //     message: '登录状态已过期，请重新登录',
      //     type: 'error',
      //     duration: 5 * 1000
      //   })

      //   // 清除登录状态
      //   store.commit('CLEAR_LOGIN_STATE')

      //   // 重定向到登录页
      //   setTimeout(() => {
      //     window.location.href = '/#/login?redirect=' + encodeURIComponent(window.location.hash.slice(1))
      //   }, 1000)
      // }

      return Promise.reject(new Error(res.data.message || '请求错误'))
    } else {
      // HTTP 200 但业务失败（success=false）
      if (res.data && res.data.success === false) {
        return Promise.reject(new Error(res.data.message || '操作失败'))
      }
      return res
    }
  },
  error => {
    console.log('请求错误: ' + error)
    
    // 处理网络错误
    if (error.response) {
      // 服务器响应错误状态码
      if (error.response.status === 401) {
        // ElMessage({
        //   message: '登录状态已过期，请重新登录',
        //   type: 'error',
        //   duration: 3 * 1000
        // })
        
        // // 清除登录状态
        // store.commit('CLEAR_LOGIN_STATE')
        
        // // 重定向到登录页
        // const currentPath = window.location.hash.slice(1)
        // setTimeout(() => {
        //   router.push(`/login?redirect=${encodeURIComponent(currentPath)}`)
        // }, 1000)
      } else if (error.response.status === 403) {
        ElMessage({
          message: '无权限访问该资源',
          type: 'error',
          duration: 3 * 1000
        })
      } else {
        ElMessage({
          message: error.response.data?.message || '服务器错误，请稍后再试',
          type: 'error',
          duration: 3 * 1000
        })
      }
    } else {
      ElMessage({
        message: error.message || '网络连接失败，请检查您的网络',
        type: 'error',
        duration: 3 * 1000
      })
    }
    
    return Promise.reject(error)
  }
)

export default service 